import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import JourneyAnalytics from './pages/JourneyAnalytics';
import VisitorMetrics from './pages/VisitorMetrics';
import Settings from './pages/Settings';
import JourneyStageAdmin from './pages/JourneyStageAdmin';
import UserManagement from './pages/UserManagement';
import MemberDetail from './pages/MemberDetail';
import ChangePassword from './pages/ChangePassword';
import Workflows from './pages/Workflows';
import PeopleActivityFeed from './pages/PeopleActivityFeed';
import ServiceAnalytics from './pages/ServiceAnalytics';
import GeographicDashboard from './pages/GeographicDashboard';
import LeadershipAnalytics from './pages/LeadershipAnalytics';
import ContactCompletenessReport from './pages/ContactCompletenessReport';
import MembershipMaintenance from './pages/MembershipMaintenance';
import MembershipCriteriaManagement from './pages/MembershipCriteriaManagement';

const App: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    document.title = 'Grace Fellowship Analytics Dashboard';
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading application...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/journey-analytics" element={<JourneyAnalytics />} />
        <Route path="/visitor-metrics" element={<VisitorMetrics />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/journey-admin" element={<JourneyStageAdmin />} />
        <Route path="/user-management" element={<UserManagement />} />
        <Route path="/workflows" element={<Workflows />} />
        <Route path="/activity-feed" element={<PeopleActivityFeed />} />
        <Route path="/service-analytics" element={<ServiceAnalytics />} />
        <Route path="/geographic" element={<GeographicDashboard />} />
        <Route path="/leadership" element={<LeadershipAnalytics />} />
        <Route path="/contact-completeness" element={<ContactCompletenessReport />} />
        <Route path="/membership-maintenance" element={<MembershipMaintenance />} />
        <Route path="/membership-criteria" element={<MembershipCriteriaManagement />} />
        <Route path="/member/:memberId" element={<MemberDetail />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
};

export default App;
 